import { render, staticRenderFns } from "./PageUsersUpdate.vue?vue&type=template&id=4a0c64ac&scoped=true&"
import script from "./PageUsersUpdate.vue?vue&type=script&lang=ts&"
export * from "./PageUsersUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./PageUsersUpdate.vue?vue&type=style&index=0&id=4a0c64ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c64ac",
  null
  
)

export default component.exports